import { render, staticRenderFns } from "./OrderFabricReadyMadeTypeTable.vue?vue&type=template&id=78f50bc6&"
import script from "./OrderFabricReadyMadeTypeTable.vue?vue&type=script&lang=js&"
export * from "./OrderFabricReadyMadeTypeTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderFabricReadyMadeTypeTable.vue?vue&type=style&index=0&id=78f50bc6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports